import React from "react";

const scaleChromatic = require("d3-scale-chromatic");

// REF
// https://medium.com/code-nebula/automatically-generate-chart-colors-with-chart-js-d3s-color-scales-f62e282b2b41

// backgroundColor: [
//   "#2f7ed8",
//   "#0d233a",
//   "#8bbc21",
//   "#910000",
//   "#1aadce",
//   "#492970",
//   "#f28f43",
//   "#77a1e5",
//   "#c42525",
//   "#a6c96a",
// ],
function useColors() {
  const initialColorRange = {
    colorStart: 0,
    colorEnd: 1,
    useEndAsStart: true,
  };

  const calculatePoint = (i, intervalSize, colorRangeInfo) => {
    var { colorStart, colorEnd, useEndAsStart } = colorRangeInfo;
    return useEndAsStart
      ? colorEnd - i * intervalSize
      : colorStart + i * intervalSize;
  };

  const interpolateColors = (
    dataLength,
    colorScale = scaleChromatic.interpolateRainbow,
    colorRangeInfo = initialColorRange
  ) => {
    var { colorStart, colorEnd } = colorRangeInfo;
    var colorRange = colorEnd - colorStart;
    var intervalSize = colorRange / dataLength;
    var i, colorPoint;
    var colorArray = [];

    for (i = 0; i < dataLength; i++) {
      colorPoint = calculatePoint(i, intervalSize, colorRangeInfo);
      colorArray.push(colorScale(colorPoint));
    }

    return colorArray;
  };

  return {
    interpolateColors,
  };
}

export default useColors;
